<template lang="pug">
    input#barcode-scanner-input(ref="scanner" @blur="scannerBlurHandler()" maxlength="1")
</template>

<script>
export default {
    name: 'barcode-scanner-handler',
    props: {},
    data: function(){
        return {}
    },
    computed: {},
    methods: {
        onBarcodeScanned: function(code){
            if(document.activeElement.tagName === 'INPUT' && document.activeElement.id !== 'barcode-scanner-input'){
                let charsToRemove = code.length
                //por algún motivo esto no funciona
                document.activeElement.value = document.activeElement.value.slice(0, (charsToRemove * -1))
            }
            this.$emit('codescanned', code)
        },
        scannerBlurHandler(){            
            setTimeout(()=>{
                if(document.activeElement.tagName === 'INPUT') return
                this.focusScanner()
            }, 10)
        },
        focusScanner(){
            document.getElementById('barcode-scanner-input').focus()
        },
    },
    watch: {},
    components: {},
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    mounted: function(){
        this.$barcodeScanner.init(this.onBarcodeScanned)
        this.focusScanner()
        let inputsArray = document.querySelectorAll('input')
        inputsArray.forEach(elem => {
            if(elem.id === 'barcode-scanner-input') return
            elem.addEventListener('blur', this.focusScanner)
        })
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    beforeDestroy: function(){
        let inputsArray = document.querySelectorAll('input')
        inputsArray.forEach(elem => {
            elem.removeEventListener('blur', this.focusScanner)
        })
        this.$barcodeScanner.destroy()
    },
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss" scoped>
    #barcode-scanner-input{
        opacity: 0;
        position:fixed;
        top:0;
        left: 0;
        margin-left: -1000px;
    }
</style>